/** withOpenIMMessageLanguage 将发送时语言写入 OpenIM 原生 ex，供服务端审核回调读取。 */
export function withOpenIMMessageLanguage<T>(message: T, language: string): T {
  if (!message || typeof message !== 'object' || Array.isArray(message)) return message;
  if (language.length > 64 || !/^[a-zA-Z]{2,8}(?:-[a-zA-Z0-9]{1,8})*$/.test(language)) return message;
  const ex = 'ex' in message ? message.ex : undefined;
  let extension: Record<string, unknown> = {};
  if (ex !== undefined && ex !== '') {
    // ex 可由其他业务占用；无法识别为 JSON 对象时保留原值，不为语言覆盖旧协议数据。
    if (typeof ex !== 'string') return message;
    try {
      const parsed: unknown = JSON.parse(ex);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return message;
      extension = parsed as Record<string, unknown>;
    } catch {
      return message;
    }
  }
  return { ...message, ex: JSON.stringify({ ...extension, qiyunLanguage: language }) };
}
